import Rollbar from 'rollbar';

export default Rollbar;
